import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const SkeletonLoader = () => (
  <Box gap="s8">
    <Box gap="s24">
      <Box
        width="full"
        gap="s16"
        flexDirection="row"
        justifyContent="flexStart"
        alignItems="center"
        paddingBottom="s6"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" width="full" alignItems="flexEnd">
          <Box flexDirection="row" gap="s16">
            <Skeleton height="s32" width="s120" />
          </Box>
          <Box flexDirection="row" gap={'s16'} alignItems="center">
            <Skeleton height="s32" width="s200" />
          </Box>
        </Box>
      </Box>
    </Box>

    <Box
      flexDirection="row"
      borderRadius={{
        all: 'abs016',
      }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Box flexGrow paddingX="s24" paddingY="s16" gap="s16">
        <Skeleton height="s16" width="s120" />
        <Box paddingY="s12" gap="s16">
          <Skeleton height="s8" width="full" />
          <Skeleton height="s8" width="s200" />
          <Skeleton height="s32" width="s80" />
        </Box>
      </Box>
      <Box width="s1" background="grey300" />
      <Box flexGrow paddingX="s24" paddingY="s16" gap="s16">
        <Skeleton height="s16" width="s120" />
        <Box paddingLeft="s16" paddingY="s12" gap="s16">
          <Skeleton height="s12" width="s200" />
          <Skeleton height="s12" width="s200" />
          <Skeleton height="s12" width="s200" />
        </Box>
      </Box>
    </Box>
  </Box>
)

export default SkeletonLoader
